<template>
  <div>
    <form data-vv-scope="formulario-documento">
      <b-row>
        <b-col>
          <b-col g="12" md="12" sm="12">
            <b-form-group label="Nombre" horizontal>
              <b-form-input
                v-model="selectedDocumentos.descripcion"
                type="text"
                id="nombre"
                name="nombre"
                data-vv-as=" "
                v-validate="'required'"
                @keydown.enter.prevent="onEnterKeyPress"
              ></b-form-input>
              <span class="text-danger span-error small">
                {{ errors.first('formulario-documento.nombre') }}
              </span>
            </b-form-group>
          </b-col>
          <hr />
          <b-col>
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <div>
                  <b-button
                    variant="primary"
                    v-if="!selectedDocumentos.editar"
                    @click="nuevoFolder()"
                  >
                    <i class="fa fa-folder"></i>
                    Crear
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CarpetaDocumentosEmpresa',
  props: ['padre', 'empresa', 'id'],

  data: function () {
    return {}
  },
  computed: {
    ...mapState('documentosEmpresa', ['selectedDocumentos']),
  },
  methods: {
    ...mapActions('documentosEmpresa', ['guardaFolder']),
    async nuevoFolder() {
      this.$validator
        .validateAll('formulario-documento')
        .then(async (result) => {
          if (result) {
            this.selectedDocumentos.padre_id = this.padre
            this.selectedDocumentos.empresaId = this.empresa
            this.selectedDocumentos.tipo = 'folder'
            await this.guardaFolder()
            this.$emit('closeModalCrear')
          }
        })
    },
    resetForm: function () {
      this.selectedDocumentos.descripcion = null
      this.selectedDocumentos.activo = null
      this.$refs.adjuntode.reset()
    },
    /**
     * Desactivar el comportamiento predeterminado del evento "Enter" en los campos de entrada Input.
     * @author Fernando Claros
     */
    onEnterKeyPress(event) {
      // Verificar si la tecla presionada es "Enter" (código 13)
      if (event.keyCode === 13) {
        // Prevenir el comportamiento predeterminado del "Enter"
        event.preventDefault();
      }
    },
  },
  watch: {},
}
</script>
